// Order here reflects order in addon panel
import "storybook-readme/register";
import "@storybook/addon-knobs/register";
import "@storybook/addon-actions/register";

// Order of this one doesn't matter
import "@storybook/addon-options/register";
import "@storybook/addon-links/register";
